import { render, staticRenderFns } from "./GoToCheckout.vue?vue&type=template&id=0421e2b9&lang=pug&"
import script from "./GoToCheckout.vue?vue&type=script&lang=js&"
export * from "./GoToCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports